module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0017.jpg?v=1f78c3c6";